import { getSelectors } from '@ngrx/router-store';

export {
  ROUTER_NAVIGATED,
  RouterNavigatedAction,
  DefaultRouterStateSerializer,
} from '@ngrx/router-store';

export const { selectRouteParam, selectRouteData } = getSelectors();
